import { Button, TextField, Typography } from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { Box, Stack } from '@mui/system'
import { useRouter } from 'next/router'
import { AxiosError } from 'axios'
import { PortalErrorResponse } from '@fc/saas-backoffice-client'
import { AuthCard } from '@/molecules/AuthCard'
import { LoadingButton } from '@/molecules/LoadingButton'
import { feedbackDialogStore } from '@/stores/feedback-dialog.store'
import { clientSideAxios } from '@/tools/client/client-side-axios'

interface IForgotPasswordFormState {
  email: string
}

export const ForgotPasswordTemplate = () => {
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<IForgotPasswordFormState>({
    mode: 'onChange',
    defaultValues: {
      email: '',
    },
  })

  const { openDialog } = feedbackDialogStore(({ openDialog }) => ({
    openDialog,
  }))

  const router = useRouter()

  const onSubmit = handleSubmit(async (data) => {
    try {
      await clientSideAxios.post('/public/auth/recover-password', data)

      openDialog('success', 'E-mail enviado com sucesso')
    } catch (error) {
      let message =
        'Não foi possível recuperar a senha, tente novamente mais tarde'

      if (error instanceof AxiosError) {
        const axiosError = error as AxiosError<PortalErrorResponse>

        if (axiosError?.response?.data) {
          message = axiosError.response.data.title
        }
      }

      openDialog('error', message)
    }
  })

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
      }}
    >
      <AuthCard>
        <Typography
          variant="h3"
          color="primary"
          textAlign="center"
          fontWeight={700}
          gutterBottom
        >
          Esqueci minha senha
        </Typography>

        <Typography textAlign="center" gutterBottom>
          Insira no campo abaixo seu e-mail para recuperar o seu acesso.
        </Typography>

        <form onSubmit={onSubmit}>
          <Stack spacing={3}>
            <Controller
              control={control}
              name="email"
              render={({ field }) => (
                <TextField
                  margin="dense"
                  type="email"
                  fullWidth
                  label="E-mail"
                  {...field}
                />
              )}
              rules={{
                required: 'Campo E-mail é obrigatório',
              }}
            />

            <Stack direction="row" justifyContent="space-between">
              <Button
                variant="text"
                size="large"
                onClick={() => {
                  router.push('/')
                }}
              >
                Voltar
              </Button>

              <LoadingButton
                type="submit"
                color="primary"
                variant="contained"
                isLoading={isSubmitting}
              >
                Enviar email
              </LoadingButton>
            </Stack>
          </Stack>
        </form>
      </AuthCard>
    </Box>
  )
}
